module.exports = __webpack_public_path__ + "static/media/team4.650b7344.jpg";